import React from "react";

import { Collapse, Row, Col, Well } from "react-bootstrap";
import PropTypes from "prop-types";

import DepartmentSelect from "../common/DepartmentSelect";
import StatusSelect from "../common/StatusSelect";

const DepartmentCategoryFilters = ({
  filters,
  onChange,
  onReset,
  open,
  loading
}) => (
  <Collapse in={open}>
    <div className="filter-container">
      <Well>
        <Row className="mb-0">
          <Col md={3}>
            <DepartmentSelect
              value={filters.department}
              isMulti
              onChange={(value) => onChange("department", value)}
            />
          </Col>
          <Col md={3}>
            <StatusSelect
              value={filters.status}
              onChange={(value) => onChange("status", value)}
            />
          </Col>
          <Col md={3}>
            <button
              disabled={loading}
              className="btn btn-warning full-width"
              type="button"
              onClick={() => onReset()}
            >
              Reset
            </button>
          </Col>
        </Row>
      </Well>
    </div>
  </Collapse>
);

DepartmentCategoryFilters.propTypes = {
  filters: PropTypes.object,
  onChange: PropTypes.func,
  onReset: PropTypes.func,
  open: PropTypes.bool,
  loading: PropTypes.bool
};

export default DepartmentCategoryFilters;
